module.exports = __webpack_public_path__ + "img/watage_2.f8e7aa34.png";